$(document).ready(function() {
  document.querySelectorAll('.form-verification').forEach((parent) => {
    const input = parent.querySelectorAll('input');
    input.forEach((inpt, idx) => {
      inpt.addEventListener('keyup', (e) => {

        if (e.code == 'Backspace') {
          try {
            input.value = '';
            input[idx - 1].focus();
            // Set focus to end
            input[idx - 1].setSelectionRange(
              input[idx - 1].value.length,
              input[idx - 1].value.length
            );
          } catch (e) {}
        } else {
          if (!(/^-?\d+\.?\d*$/.test(e.target.value))) return false;
          try {
            input[idx + 1].focus();
            input[idx + 1].setSelectionRange(
              input[idx + 1].value.length,
              input[idx + 1].value.length
            );
          } catch (e) {}
        }
      });
    });
  });
});
